import { useNavigate } from 'react-router-dom';
import { Title } from '../../Components/Atoms';
import { Donut } from '../../Components/Organisms/Graphs';
import { ArrowRightIcon, BatteryIcon } from '../../Assets/images/svgs';
import { WidgetLegend } from '../../Components/Atoms';
import { Button } from '@chakra-ui/react';
import PATHS from "../../Routes/paths";
import { MODEL_COLORS } from '../../Assets/styles/colors';
import NoDataWidget from '../NoDataWidget';
import { useMemo } from 'react';

const BatteriesUnitStat = ({ data = [] }) => {
  const Navigate = useNavigate();
  const parser = { x: "label", y: "count" };

  const graphData = useMemo(() => {
    if (data && data.batteryStats) {
      let newData = [...data.batteryStats];

      if (data.batteryStats.length > 4) {
        newData = newData.slice(0, 3);

        let count = data.batteryStats.slice(3,).reduce((acc, data) => acc + data.count, 0);
        newData.push({ manf: "Others", count: count });
      }

      return newData.map((d, idx) => ({ label: d.manf, count: d.count, color: MODEL_COLORS[idx] }));
    }
    else
      return [];
  }, [data]);
  const total = graphData.reduce((acc, item) => acc + item.count, 0)

  return (
    <div className="widget-group widget-1 unit-widget">
      {
        graphData.length ? <article className="widget-main">
          <header className="widget-header">
            <Title variant="md" fixed>Batteries</Title>
          </header>

          <main className="widget-section">
            <div className="widget-chart">
              <Donut title="Batteries" data={graphData} parser={parser} />
              <span className="widget-chart-text">
                <span className="total">{total}</span>
                <span className="units">Units</span>
              </span>
            </div>

            <div className="widget-legend">
              <WidgetLegend sparse data={graphData} parser={parser} showPercent={false} doSort={false} />
            </div>

            <div className="widget-link">
              <Button variant={"ghost"} rightIcon={<ArrowRightIcon />} onClick={() => Navigate(PATHS.BATTERIES)}>
                View Reports
              </Button>
            </div>
          </main>
        </article> : <NoDataWidget
          heading={"Batteries"}
          showBtn={true}
          icon={BatteryIcon}
          info={"No batteries available"}
          btnTitle={"Add New Battery"}
          onClick={() => Navigate(PATHS.ADDBATTERY)}
        />
      }
    </div>
  );
}

export default BatteriesUnitStat;